/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-13, 12:21:13
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-11, 16:29:11
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import logo from  "images/logo-softwearehouse.png";

import './style.sass';

export default () => 
  (
    <div className="brand">
      <img 
        className="brand__image"
        src={logo} 
      />
    </div>
  )



// WEBPACK FOOTER //
// ./src/rcapp/components/layout/brand/index.js